import { AddressState, AddressTypes, AddressActionTypes } from './types'
import { Reducer } from 'redux'

const initialState: AddressState = {
  addresses: []
}

type ReducerOpts = Reducer<AddressState, AddressActionTypes>
const reducer: ReducerOpts = (state = initialState, action: AddressActionTypes): AddressState => {
  let index = -1
  switch (action.type) {
    case AddressTypes.ADDRESS_CREATE:
      return { ...state, addresses: [...state.addresses, action.payload] }
    case AddressTypes.ADDRESS_UPDATE:
      index = state.addresses.findIndex(obj => obj.id === action.payload.id)
      return {
        ...state,
        addresses: [
          ...state.addresses.slice(0, index),
          action.payload,
          ...state.addresses.slice(index + 1)
        ]
      }
    case AddressTypes.ADDRESS_DELETE:
      index = state.addresses.findIndex(obj => obj.id === action.payload)
      return {
        ...state,
        addresses: [
          ...state.addresses.slice(0, index),
          ...state.addresses.slice(index + 1)
        ]
      }
    case AddressTypes.ADDRESS_GET:
      return { ...state, address: action.payload }
    case AddressTypes.ADDRESS_GET_LIST:
      return { ...state, addresses: action.payload }
    default:
      return state
  }
}

export default reducer
